/* eslint-disable @typescript-eslint/no-explicit-any */
import * as Yup from 'yup'

import {
  ALL_TSHIRT_SIZES,
  EVENT_SHIRT_OPTIONS,
  SHIRT_KEY,
  TSHIRT_SIZES,
} from 'constants/models'
import { isCategoryMultisports } from 'utils/ApiHelpers'

const validateShirtType = (key: string, value: any, testContext: any) => {
  if (
    key === SHIRT_KEY.SHIRT1 ||
    (key === SHIRT_KEY.SHIRT2 && testContext.parent.hasShirt2)
  ) {
    if (
      testContext.parent.shirtDetails &&
      'TYPE_OPTIONS' in testContext.parent.shirtDetails[key]
    ) {
      if (value !== undefined && value !== null) {
        const shirtOptions =
          testContext.parent.shirtDetails[key]?.TYPE_OPTIONS ||
          EVENT_SHIRT_OPTIONS

        if (!shirtOptions.includes(value)) {
          return testContext.createError({
            message: `Invalid ${
              testContext.parent.shirtDetails[key].LABEL || 'Shirt'
            } type selected`,
            path: testContext.path, // Fieldname
          })
        }
        return true
      }
      return testContext.createError({
        message: `${
          testContext.parent.shirtDetails[key].LABEL || 'Shirt'
        } type is required`,
        path: testContext.path, // Fieldname
      })
    }
  }
  return true
}

const validateShirtSize = (key: string, value: any, testContext: any) => {
  if (
    key === SHIRT_KEY.SHIRT1 ||
    (key === SHIRT_KEY.SHIRT2 && testContext.parent.hasShirt2)
  ) {
    if (value !== undefined && value !== null) {
      const options =
        testContext.parent.shirtDetails[key]?.SIZE_OPTIONS ||
        Object.keys(TSHIRT_SIZES)

      if (!options.includes(value)) {
        return testContext.createError({
          message: `Invalid ${
            testContext.parent.shirtDetails[key].LABEL || 'Shirt'
          } size selected`,
          path: testContext.path, // Fieldname
        })
      }
      return true
    }
    return testContext.createError({
      message: `${
        testContext.parent.shirtDetails[key].LABEL || 'Shirt'
      } size is required`,
      path: testContext.path, // Fieldname
    })
  }
  return true
}

const validateJerseyField = (value: any, testContext: any) => {
  if (
    testContext.parent.hasJersey &&
    testContext.parent.relayEvent.includes('BIKE')
  )
    if (value !== undefined && value !== null) {
      return value && value.toString().trim().length > 0
    } else return false

  return true
}

const schema = {
  categoryId: Yup.string().required('Category ID is required'),

  // TRIATHLON/DUATHLON relay categories
  isTriathlon: Yup.boolean(),
  teamType: Yup.string(),
  relayEvent: Yup.array()
    .of(Yup.string())
    .test(
      'required-with-triathlon',
      'Relay Event is required',
      (value, testContext) => {
        if (isCategoryMultisports(testContext.parent))
          return Array.isArray(value) && value.length > 0
        return true
      },
    ),

  shirtSize: Yup.mixed().test({
    name: 'required-with-hasShirt',
    test: (value: any, testContext: any) =>
      validateShirtSize(SHIRT_KEY.SHIRT1, value, testContext),
  }),
  shirtType: Yup.string().test({
    name: 'required-with-hasShirtType',
    test: (value: any, testContext: any) =>
      validateShirtType(SHIRT_KEY.SHIRT1, value, testContext),
  }),

  // 2nd shirt
  hasShirt2: Yup.boolean(),
  shirtSize2: Yup.mixed().test({
    name: 'required-with-hasShirt2',
    test: (value: any, testContext: any) =>
      validateShirtSize(SHIRT_KEY.SHIRT2, value, testContext),
  }),
  shirtType2: Yup.string().test({
    name: 'required-with-hasShirtType2',
    test: (value: any, testContext: any) =>
      validateShirtType(SHIRT_KEY.SHIRT2, value, testContext),
  }),

  // bike jersey
  hasJersey: Yup.boolean(),
  jerseySize: Yup.mixed()
    .test('required-with-hasJersey', 'Jersey is required', validateJerseyField)
    .oneOf(Object.keys(ALL_TSHIRT_SIZES)),

  teamName: Yup.string().max(50, 'Team name must not exceed 50 characters'),

  bibName: Yup.string()
    //   .required('Name on bib is required')
    .max(25, 'Name on bib must not exceed 25 numbers'),

  // subCategories
  subCategories: Yup.mixed().nullable(),
  subCategory: Yup.string().test({
    name: 'validate-length',
    test: (value: any, testContext: any) => {
      // console.log({ value, testContext })
      if (
        'subCategories' in testContext.parent &&
        Object.keys(testContext.parent.subCategories || {}).length > 0
      ) {
        if (
          'required' in testContext.parent.subCategories &&
          testContext.parent.subCategories.required
        ) {
          if ((value || '').length === 0) {
            return testContext.createError({
              message: `${testContext.parent.subCategories.label} is required`,
              path: testContext.path, // Fieldname
            })
          }
        }
        if (value !== undefined && value !== null) {
          const subCategoryValues =
            testContext.parent.subCategories.options.map((a) => a.name)
          if (!subCategoryValues.includes(value)) {
            return testContext.createError({
              message: `Invalid ${testContext.parent.subCategories.label} selected`,
              path: testContext.path, // Fieldname
            })
          }
        }
      }
      return true
    },
  }),
}

export default schema
